export default __webpack_public_path__ + "static/media/multi-chevron.23550c58.svg";